


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalVue from './Modal.vue';

import Game from '../../engine/Game';

import {default as toClipboard} from 'copy-to-clipboard';


@Component({
    components: {
        ModalVue
    },
})
export default class TopbarVue extends Vue {

    @Prop() private game!: Game;

    mp_users: any[] = [];

    time: string = '';

    show_info = false;

    mounted(){

        if(this.game.multiplayer){

            this.mp_users = this.game.multiplayer.user_data;

            this.game.multiplayer.onUserData((users) => {

                if(users) this.mp_users = users; // TODO


            });


        }

        this.updateTime();
        this.updateTimeInterval = setInterval(this.updateTime.bind(this), 1000);

    }
    
    beforeDestroy(){

        clearInterval(this.updateTimeInterval);

    }

    updateTimeInterval: number = 0;

    updateTime(){

        const current_or_end = this.game.end ? this.game.end : new Date();


        let diff = current_or_end.getTime() - this.game.start.getTime();
        diff = Math.floor(diff / 1000);

        let s = diff % 60;

        diff = (diff - s) / 60;
        let m = diff % 60;

        diff = (diff - m) / 60;
        let h = diff % 99;

    
        this.time = 
            `${h}`.padStart(2, '0') + ':' + 
            `${m}`.padStart(2, '0') + ':' +
            `${s}`.padStart(2, '0');

        

    }


    get_avatar(avatar:string){

        if(!avatar) return '';

        return require(`@/assets/avatars/${avatar}_256.png`);
    }

    copy_mp_link(){

        let join_url = window.location.href.split('/#/game')[0];
        join_url += '/#/multiplayer/' + this.game.multiplayer!.game_id;

        toClipboard(join_url, {
            debug: true,
            message: 'Pulsa #{key} para copiar',
            format: "text/plain",
            onCopy: () => { console.log('Copied') },
        });

    }

}

